"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.MessageNotification = void 0;
require("./MessageNotification.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _ProductVariant = _interopRequireDefault(require("../ProductVariant/ProductVariant"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Notification component
 *
 * @method
 * @param { MessageNotificationProps } props
 * @returns MessageNotification
 */

const MessageNotification = props => {
  const {
    externalMediaElement,
    message,
    variantTypeLabel,
    variants,
    externalActionElement
  } = props;
  if (!message) {
    return null;
  }
  const componentClassName = (0, _classnames.default)('pal-c-MessageNotification', {});
  const hasMedia = !!externalMediaElement;
  const hasSwatchImage = variants?.find(item => item.image);
  const variantLabelClassName = (0, _classnames.default)('pal-c-MessageNotification__variantLabel', {
    'pal-c-MessageNotification__variantLabel--swatch': hasSwatchImage
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    role: "region",
    "aria-labelledby": "variant-id"
  }, hasMedia && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-MessageNotification__imageContainer"
  }, (0, _renderObject.renderObject)(externalMediaElement)), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-MessageNotification__messageContainer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-MessageNotification__title",
    id: "variant-id"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "p",
    textStyle: "label",
    color: "default"
  }, message)), variantTypeLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: variantLabelClassName
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "label-sm",
    textColor: "xsubtle"
  }, variantTypeLabel)), variants?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-MessageNotification__variantsList"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "pal-c-MessageNotification__listItems"
  }, variants?.map((item, index) => /*#__PURE__*/_react.default.createElement("li", {
    key: index,
    className: "pal-c-MessageNotification__item"
  }, /*#__PURE__*/_react.default.createElement(_ProductVariant.default, {
    variantTypeDescription: item.label,
    swatchImage: item.image
  }))))), externalActionElement && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-MessageNotification__action"
  }, (0, _renderObject.renderObject)(externalActionElement))));
};

/**
 * Property type definitions
 * @typedef MessageNotificationProps
 * @type {object}
 * @property {object} externalMediaElement - the image coming from web-site
 * @property {string} message - the notification description for the Notification
 * @property {string} variantTypeLabel - the variant type label for the Notification
 * @property {array} variants - List os all variants from web-site
 * @property {object} externalActionElement - Show More/Show Less action from web-site
 */
exports.MessageNotification = MessageNotification;
const propTypes = exports.propTypes = {
  /**
   * the image coming from web-site
   */
  externalMediaElement: _propTypes.default.object,
  /**
   * the product name for the Notification
   */
  message: _propTypes.default.string,
  /**
   * variant type label coming from web-site
   */
  variantTypeLabel: _propTypes.default.string,
  /**
   * variant type label coming from web-site
   */
  variants: _propTypes.default.array,
  /**
   * Show More/Show Less action from web-site
   */
  externalActionElement: _propTypes.default.object
};
MessageNotification.propTypes = propTypes;
var _default = exports.default = MessageNotification;